import axios from 'axios';
import { getCookie } from '@/utils/cookie-utils.js'
import app from "@/main.js";

const client = axios.create({
	// baseURL: 'http://127.0.0.1/',
	// baseURL: 'https://ertiqatest.mahdi.cloud/',
	// baseURL: 'https://ertiqa.svod.app/',
	// baseURL: 'https://ertiqa.v2.svod.app/',
	// baseURL: 'http://www.ertiqatest.tk/',
	baseURL: 'https://ertiqa.bitcode.sa/',
});

// remove other headers

// todo
// 1 - make the interceptor renew the token if expired

client.interceptors.request.use(
	config => {
		config.headers["Authorization"] = getCookie('token');
		return config;
	}
);

client.interceptors.response.use(
	(res) => {
		return res
	},
	(err) => {
		if (err.response) {
			if (err.response.status === 401) {
				if (err.request.responseURL.indexOf("myprofile/me") != -1) {
					console.log("allowed 401")
				} else {
					console.log("401")
					console.log(app.$router.push({ name: "non-authorized"}))
				}
			}
		}
	}
)

export default client;
